<section class="mfa">
    <div class="form-wrap">
        <form [formGroup]="verifyCodeForm" (ngSubmit)="verificationCodeSubmit(verifyCodeForm)">
            <div class="left-aligned">
                <h2>Enter your verification code</h2>
            </div>
            <p>
                A verification code has been sent to your mobile phone number on record:
                {{ phone }}. If you do not receive the code within 5 minutes, click “Request New Code” to start over.​
            </p>
            <p class="note">Note: the verification code is only valid for 5 minutes.</p>
            <div class="inline-form">
                <mat-form-field style="width: 100%" appearance="fill">
                    <mat-label>Verification Code</mat-label>
                    <input type="text" matInput formControlName="token" maxlength="30" />
                    <!--mat-error for mobile-->
                    <mat-error>Invalid Verification Code</mat-error>
                </mat-form-field>
                <div>
                    <button
                        style="width: 100%"
                        class="auth-form-submit"
                        mat-flat-button
                        type="submit"
                        [disabled]="disableSubmit"
                        [class.disabled]="disableSubmit"
                        color="primary"
                    >
                        Verify
                    </button>
                </div>
            </div>
            <div *ngIf="invalidVerificationCode">
                <p class="customError">Invalid Verification Code</p>
            </div>

            <ng-container>
                <!--Commenting below out as it may come back-->
                <!-- <ng-container *ngIf="!hideLogon">
                    <div style="margin-top: 2rem" class="links">
                        <a style="color: var(--tenant-header)" (click)="logon()">Logon</a>
                    </div>
                </ng-container> -->

                <div style="margin-top: 2rem" class="links">
                    <a style="color: var(--tenant-header)" (click)="requestNewToken()">Request New Code</a>
                </div>
            </ng-container>
            <hr />
        </form>
        <div class="qna">
            <h3>Why is two-factor authentication required?</h3>
            <p>
                Stolen, reused, and weak passwords are a leading cause of security breaches. Two-factor authentication adds an extra layer of security by
                requiring you to enter a verification code each time you log in. Adding this verification step significantly reduces the risk of your security
                being compromised.​
            </p>
        </div>
    </div>
</section>
<ddj-spinner *ngIf="isLoading"></ddj-spinner>
